export default {"src":"/_next/static/media/img_promotion_section1.2fd4f857.svg","height":280,"width":1180,"blurWidth":0,"blurHeight":0};